import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type DeviceInfoState = {
  deviceType: string
  os: string
  osVersion: string
}

const initialState: DeviceInfoState = {
  deviceType: "",
  os: "",
  osVersion: ""
}

const deviceInfoSlice = createSlice({
  name: "deviceInfo",
  initialState,
  reducers: {
    setDeviceInfo: (state, action: PayloadAction<DeviceInfoState>) => {
      state.deviceType = action.payload.deviceType
      state.os = action.payload.os
      state.osVersion = action.payload.osVersion
    },
    clearDeviceInfo: (state) => {
      state.deviceType = ""
      state.os = ""
      state.osVersion = ""
    }
  }
})

export const { setDeviceInfo, clearDeviceInfo } = deviceInfoSlice.actions
export default deviceInfoSlice
